export const ToastrMessages = {
  EmailEnviado:"Informações enviadas com sucesso.",
  AutenticacaoExpirou:"A autenticação do sistema expirou. Favor recarregar a página.",
  ConteudoIndisponivel:"Conteúdo indisponível no momento. Tente novamente em instantes.",
  MuitosAcessos: "Detectamos muitos acessos em um curto período de tempo. Por favor, aguarde alguns instantes antes de tentar novamente."
}
